import { useTranslation } from "react-i18next";
import useProgressPage from "./hooks/useProgressPage";
import PageContainer from "../../components/PageContainer";
import ProgressLine from "./ProgressLine";

const ProgressPage = () => {
  const { t } = useTranslation();
  const { progress, progressLoading } = useProgressPage();

  return (
    <PageContainer header={t("page.curriculum")} isLoading={progressLoading}>
      <div style={{ width: "100%" }}>
        {progress?.map((progressLine) => (
          <ProgressLine key={progressLine?.topic?.id} {...progressLine} />
        ))}
      </div>
    </PageContainer>
  );
};

export default ProgressPage;
